import type { CSSProperties, FC } from "react";
import React from "react";
import classNames from "classnames";
import { LogoAnim } from "../LogoLoader";
import css from "./Loader.module.css";

type LoaderProps = {
  loading?: boolean;
  height?: CSSProperties["height"];
};

const Loader: FC<LoaderProps> = ({ loading, height }) => {
  return (
    <div className={css.loaderOuter}>
      <div
        role="progressbar"
        aria-busy={loading ? "true" : "false"}
        aria-valuetext="loading"
        className={classNames(css.loaderOverlay, {
          [css.loading]: loading,
        })}
        style={height ? { height } : undefined}
      >
        {loading && <LogoAnim />}
      </div>
    </div>
  );
};

export default Loader;
